export function getErrorMessage(error) {
  if (error.message && error.message.error) {
    return error.message.error;
  }
  return undefined;
}
